module.exports = __webpack_public_path__ + "static/media/munch6.c2e5d332.wav";